/** @format */

import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import getRedirectionLink from 'src/utils/helper';
import { format } from 'date-fns';
import { KnowledgeBaseRating } from 'src/components/knowledegeBase/rating';
import { KnowledgeBaseItem } from 'src/components/knowledegeBase/item';

export function KnowledgeBaseWidget({ data }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleSearchClick = () => {
    navigate(`/knowledge-base/${data.kb}/?query`);
  };

  return (
    <div className="knowledge_base-widget" data-width={data.w} data-height={data.h}>
      <div className="knowledge_base-widget--title">
        <h2>{data.title}</h2>
        <button className="search-button" onClick={handleSearchClick} />
      </div>
      {data.kb_articles && (
        <div className="knowledge_base-widget--list-wrapper">
          <div className="knowledge_base-widget--list">
            {data.kb_articles.length > 0 ? (
              data.kb_articles.map(item => <KnowledgeBaseItem item={item} kb={data.kb} key={item.nid} />)
            ) : (
              <p className="knowledge_base-widget--list-empty">{t('widget.noNews')}</p>
            )}
          </div>
        </div>
      )}
      <div className="knowledge_base-widget--link">
        <Link to={`/knowledge-base/${data.kb}`}>{t('common.allArticles')}</Link>
      </div>
    </div>
  );
}
